module.exports = __webpack_public_path__ + "img/logo-global.f121a3c5.jpg";